import { classNames } from "../../utils";

export type SkeletonProps = {
	className?: string;
	width?: number;
	height?: number;
	type?: "text" | "circle";
};

export const Skeleton = ({ className, width, height, type = "text" }: SkeletonProps) => {
	return (
		<span
			style={{ width: width, height: height }}
			className={classNames(
				type === "text" ? "rounded-md" : "",
				type === "circle" ? "rounded-full" : "",
				"flex animate-pulse bg-skeleton",
				className,
			)}
		/>
	);
};
